<mat-card class="mat-mdc-card mdc-card cardWithShadow overflow-hidden">
  <div class="{{colorBG}} course-header d-flex justify-content-between p-12 {{colorTxt}}">
    <mat-card-title class="mat-mdc-card-title m-b-0 f-s-16"> {{ room.name }}</mat-card-title>
    <span class="d-flex align-items-center gap-4 f-s-14"
          [matTooltip]="'rooms.people_in_room' | translate"
          matTooltipClass="tooltip-centered">
          {{room.connectionNumber}} <i-tabler name="{{iconUser}}" class="icon-16 d-flex"></i-tabler>
        </span>
  </div>
  <mat-card-content class="mat-mdc-card-content text-center">
    <h3 class="m-b-4 f-s-16 f-w-600 text-capitalize"> {{ room.technician?.lastname }} {{ room.technician?.name }} </h3>
    <span class="f-s-12 d-flex justify-content-center align-items-center">
      <i-tabler name="mail" class="icon-16 "></i-tabler>&nbsp;{{ room.technician?.email }}
    </span>
    @if (!room.technician?.phone) {
      <span class="f-s-12 d-flex justify-content-center align-items-center">-</span>
    }
    @if (room.technician?.phone) {
      <span class="f-s-12 d-flex justify-content-center align-items-center">
        <i-tabler name="phone" class="icon-16 "></i-tabler>&nbsp;{{ room.technician?.prefix?.prefix }}
        -{{ room.technician?.phone }}
      </span>
    }
  </mat-card-content>
  <mat-divider role="separator" class="mat-divider mat-divider-horizontal" aria-orientation="horizontal"/>
  <div class="text-center p-y-8 p-x-12">
    <span
      class="d-inline-block w-100"
      [matTooltip]="tooltipKey | translate"
      [matTooltipDisabled]="!disabledBTN || !tooltipKey"
      matTooltipClass="tooltip-centered"
    >
      <button
        mat-button
        (click)="openRoom()"
        [disabled]="disabledBTN"
        class="w-100 mdc-button mat-mdc-button mat-unthemed mat-mdc-button-base"
      >Connect</button>
    </span>
  </div>
</mat-card>
